import { render, staticRenderFns } from "./OnboardingResult.vue?vue&type=template&id=790fe8ee&scoped=true&"
import script from "./OnboardingResult.vue?vue&type=script&lang=js&"
export * from "./OnboardingResult.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingResult.vue?vue&type=style&index=0&id=790fe8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fe8ee",
  null
  
)

export default component.exports